export default {
	/**
	 * Convert JSON to CSV
	 * @param {Array} json
	 * @param {string} separator
	 * @param {string} replacer
	 * @returns {string}
	 */
	jsonToCSV: function (json, separator = ';', replacer = '') {
		const header = Object.keys(json[0]);
		const csv = json
			.map(row => header.map(fieldName => this.encodeData(row[fieldName], replacer)).join(separator))
			.join('\r\n');

		return csv;
	},

	/**
	 * Convert JSON to XML
	 * @param {Array} json
	 * @param {string} rootName
	 * @param {string} childName
	 * @param {string} replacer
	 * @returns {string}
	 * */
	jsonToXML: function (json, rootName = 'root', childName = 'row', replacer = '') {
		let xml = '';
		// Create XML header
		xml += '<?xml version="1.0" encoding="UTF-8"?>' + '\n';
		xml += '<' + rootName + '>\n';

		// Create XML body
		json.forEach(item => {
			xml += '\t<' + childName + '>\n';
			Object.keys(item).forEach(
				key =>
					(xml +=
						'\t\t<' + key + '>' + this.encodeData(item[key], replacer, true) + '</' + key + '>\n')
			);
			xml += '\t</' + childName + '>\n';
		});

		// Close XML
		xml += '</' + rootName + '>\n';
		return xml;
	},

	/**
	 * Encode data to string
	 * @param {string} data
	 * @param {string} replacer
	 * @param {boolean} isXML
	 * @returns {string}
	 */
	encodeData: function (data, replacer = '', isXML = false) {
		const filter = value =>
			value === null || value === 'null' || value === undefined || value === 'undefined'
				? replacer
				: value;

		const formatNumeric = value =>
			value.match(/^-?\d+\.?\d*$/g) !== null ? value.replace('.', ',') : value;

		const dataString = String(JSON.stringify(filter(data)));
		return isXML
			? dataString
					.replace(/^"/g, '')
					.replace(/"$/g, '')
					.replaceAll('<', '&lt;')
					.replaceAll('>', '&gt;')
					.replaceAll('&', '&amp;')
					.replaceAll('"', '&quot;')
					.replaceAll('`', '&apos;')
			: formatNumeric(dataString);
	},
};
